import listIsTight from "../../logic/listIsTight";

export const orderedList = {
	block: "orderedList",
	getAttrs: (tok, tokens, i) => ({
		start: Number(tok.attrGet("start") ?? 1),
		tight: listIsTight(tokens, i),
	}),
};
